module.exports = __webpack_public_path__ + "img/1-2.022ec036.png";